'use client';

import * as ReactDOM from 'react-dom';
var unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;
export { unstable_batchedUpdates };